import { render, staticRenderFns } from "./AppServiceMain.vue?vue&type=template&id=bbe1c4c2&"
import script from "./AppServiceMain.vue?vue&type=script&lang=ts&"
export * from "./AppServiceMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports